import { render, staticRenderFns } from "./ActiveSkill.vue?vue&type=template&id=bee6e962&"
import script from "./ActiveSkill.vue?vue&type=script&lang=js&"
export * from "./ActiveSkill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports